import * as React from 'react';

import classNames from 'classnames';

import {colors} from '../../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {CopyIcon} from '../../icon/svg/copy-icon';
import {Popover} from '../../popover/popover';
import {useRefObserver} from '../../utils/hooks/use-ref-observer';

const COPY_TEXT = 'Copy';
const COPIED_TEXT = 'Copied!';

type TooltipText = 'Copy' | 'Copied!';

type Props = {
    text: string;
    size?: 'big' | 'small';
    as?: 'div' | 'button';
    popoverBodyColor?: 'light' | 'dark' | 'error';
    hasBorder?: boolean;
};

export function CopyIconButton(props: Props) {
    const {text, size, as = 'button', popoverBodyColor = 'dark', hasBorder = false} = props;

    const buttonRef = React.useRef(null);
    const {isHovered} = useRefObserver(buttonRef, ['isHovered']);

    const [tooltipText, setTooltipText] = React.useState<TooltipText>(COPY_TEXT);

    const handleCopyLink = (event: React.SyntheticEvent<any>) => {
        event.preventDefault();
        event.stopPropagation();

        navigator.clipboard.writeText(text).then(() => {
            setTooltipText(COPIED_TEXT);
        });
    };

    React.useEffect(() => {
        if (!isHovered && tooltipText === COPIED_TEXT) {
            setTooltipText(COPY_TEXT);
        }
    }, [isHovered, tooltipText]);

    const Tag = as;

    const buttonStyles = classNames('flex', 'pointer-cursor', {
        ['pad-4 border br-3']: hasBorder,
    });

    return (
        <>
            <div
                ref={buttonRef}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
                onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
            >
                <Tag
                    onClick={handleCopyLink}
                    className={buttonStyles}
                    role='button'
                    aria-label='Copy'
                >
                    <CopyIcon
                        size={size === 'small' ? 13 : 15}
                        wrapWithDiv={false}
                        color={isHovered ? colors.greyDk : colors.greyLt}
                    />
                </Tag>
            </div>
            {isHovered && (
                <Popover anchor={buttonRef.current} bodyColor={popoverBodyColor} location='top'>
                    <div className='pad-8'>{tooltipText}</div>
                </Popover>
            )}
        </>
    );
}
